export interface News {
	id: string;
	description: string;
	title: string;
	published_date: string;
	thumbnail_image: string;
	category: string;
	profile: Profile;
	is_live: boolean;
}


export interface NewsDetail {
	id: string;
	title: string;
	content: string;
	published_date: string;
	thumbnail_image: string;
	image: string;
	category: string;
	is_commentable: boolean;
	is_copyable: boolean;
	profile: Profile | null;
	live_news: LiveNews[]
}

export interface LiveNews {
	published_date: string;
	content: string;
}


export interface Comment {
	id: number;
	ip: string;
	name: string;
	content: string;
	created_at: string;
	replies: Comment[];
}

export interface NewsMetadata {
	title: string;
	description: string;
	image:string
}

export interface Profile {
	pk: string;
	thumbnail_image: string;
	name: string;
	description: string;
	facebook_url: string;
	x_url: string
}



export interface Advertisement {
	image: string;
	code: string;
	url: string;
}



export const formatDateString = (dateString: string): string => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).format(date);
  };


  export const formatDayTimeString = (dateString: string): string => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-CA", {
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).format(date);
  };
  


export async function getAdvertisements(): Promise<Advertisement[]> {
	const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
	const response = await fetch(`${API_BASE_URL}advertisements/`, {
		cache: "no-store",
	});
	if (!response.ok) {
		throw new Error("Failed to fetch advertisements");
	}
	return response.json();
}

export const ensureAbsoluteUrl = (url: string): string => {
	// Check if the URL already has a protocol (http or https)
	if (/^(http|https):\/\//.test(url)) {
	  return url;
	}
	// Prepend "https://" if the protocol is missing
	return `https://${url}`;
  };